<template lang="html">
  <div class="yo-scroll"
       :class="{'down':(state===0),'up':(state==1),refresh:(state===2),touch:touching,finish:(state===3)}"
       @touchstart="touchStart($event)"
       @touchmove="touchMove($event)"
       @touchend="touchEnd($event)"

       @scroll="(onInfinite || infiniteLoading) ? onScroll($event) : undefined">
    <div class="inner" :style="{ transform: 'translate3d(0, ' + top + 'px, 0)' }">
      <header class="pull-refresh">
        <slot name="pull-refresh">
          <span class="down-tip">下拉刷新</span>
          <span class="up-tip">松开更新</span>
          <span class="refresh-tip">正在更新中</span>
          <span class="finish-tip">更新完成</span>
        </slot>
      </header>
      <slot></slot>
      <footer class="load-more">
        <slot name="load-more">
          <span>{{loadingText}}</span>
        </slot>
      </footer>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    props: {
      offset: {
        type: Number,
        default: 40
      },
      loadingText: {
        type: String,
        default: '加载中...'
      },
      enableInfinite: {
        type: Boolean,
        default: true
      },
      enableRefresh: {
        type: Boolean,
        default: true
      },
      onRefresh: {
        type: Function,
        default: undefined,
        required: false
      },
      onInfinite: {
        type: Function,
        default: undefined,
        require: false
      }
    },
    data () {
      return {
        top: 0,
        state: 0,
        startY: 0,
        touching: false,
        infiniteLoading: false,
        clientHeight: (window.innerWidth || screen.width || document.documentElement.clientWidth || document.body.clientWidth) / 16 * 9 * 2 / 100
      }
    },
    methods: {
      touchStart (e) {
        let _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
        if (_t > 8) {
          return
        }
        this.startY = e.targetTouches[0].pageY
        this.startScroll = this.$el.scrollTop || 0
        this.touching = true
      },
      touchMove (e) {
        let _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
        if (_t > 8) {
          return
        }
        if (!this.enableRefresh || this.$el.scrollTop > 0 || !this.touching) {
          return
        }
        let diff = e.targetTouches[0].pageY - this.startY - this.startScroll
        if (diff > 0) e.preventDefault()
        this.top = Math.pow(diff, 0.8) + (this.state === 2 ? this.offset : 0)

        if (this.state === 2) { // in refreshing
          return
        }
        if (this.top >= this.offset - 500) {
          this.state = 1
        } else {
          this.state = 0
        }
      },
      touchEnd (e) {
        let _t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
        if (_t > 8) {
          return
        }
        if (!this.enableRefresh) return
        this.touching = false
        if (this.state === 2) { // in refreshing
          this.state = 2
          this.top = this.offset
          return
        }
        if (this.top >= this.offset) { // do refresh
          this.refresh()
        } else { // cancel refresh
          this.state = 0
          this.top = 0
        }
      },
      refresh () {
        this.state = 2
        this.top = this.offset
        setTimeout(() => {
          this.onRefresh(this.refreshDone)
        }, 1000)
      },
      refreshDone () {
        this.state = 3
        setTimeout(() => {
          this.state = 0
          this.top = 0
          this.infiniteLoading = false
          this.startY = 0
          this.touching = false
        }, 700)
      },

      infinite () {
        this.infiniteLoading = true
        this.onInfinite(this.infiniteDone)
        window.onceFlag = window.onceFlag || 0
        var _this = this
        if (window.onceFlag === 0) {
          window.onceFlag = 111
          window.onscroll = function (e) {
            if (!_this.enableInfinite || _this.infiniteLoading) {
              return
            }
            var t = window.scrollY || window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop
            // var scrollTop = $(this).scrollTop()
            var scrollHeight = $(document).height()
            var windowHeight = $(this).height()
            if (t + windowHeight > (scrollHeight - 100) && t > 0) {
              _this.infinite()
            }
          }
        }
      },
      infiniteDone () {
        this.infiniteLoading = false
      },

      onScroll (e) {
        // if (!this.enableInfinite || this.infiniteLoading) {
        //   return
        // }
        // let outerHeight = this.$el.clientHeight
        // let innerHeight = this.$el.querySelector('.inner').clientHeight
        // let scrollTop = this.$el.scrollTop
        // let ptrHeight = this.onRefresh ? this.$el.querySelector('.pull-refresh').clientHeight : 0
        // let infiniteHeight = this.$el.querySelector('.load-more').clientHeight
        // let bottom = innerHeight - outerHeight - scrollTop - ptrHeight
        //
        // if (bottom < infiniteHeight) this.infinite()
      }
    },
    mounted () {
      window.onceFlag = 0
      this.infinite()
    },
    destroyed () {
      window.onscroll = null
      this.top = 0
      this.state = 0
      this.startY = 0
      this.touching = false
      this.infiniteLoadin = false
    }
  }
</script>
<style>
  .yo-scroll {
    /*top: 2.5rem;*/
    /*top:  4.72rem;*/
    /*top:0;*/

    /*-webkit-overflow-scrolling: touch;*/
    /*background-color: #ddd*/

    /*position: absolute;*/
    /*top: 5.72rem;*/
    /*right: 0;*/
    /*bottom: 0;*/
    /*left: 0;*/
    /*overflow: auto;*/
    font-size: .25rem;
    color: #999;
  }

  .yo-scroll .inner {
    /*position: absolute;*/
    /*top: -.7rem;*/
    margin-top: -.7rem;
    width: 100%;
    transition-duration: 300ms;
  }

  .yo-scroll .pull-refresh {
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
    height: .7rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .yo-scroll.touch .inner {
    transition-duration: 0ms;
  }

  .yo-scroll.refresh .refresh-tip,
  .yo-scroll.finish .finish-tip,
  .yo-scroll.down .down-tip,
  .yo-scroll.up .up-tip {
    display: block;
  }

  .yo-scroll .down-tip,
  .yo-scroll .refresh-tip,
  .yo-scroll .up-tip,
  .yo-scroll .finish-tip {
    display: none;
  }

  .yo-scroll .load-more {
    height: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// PullRefresh.vue?dbdf74b2